<template>
  <div class="compare-footer">
    <el-row type="flex">
      <el-col :span="3" >
        <div class="col-inner-wrapper">
          <div class="el-text el-text--display-regular">COMPARISON</div>
        </div>
      </el-col>
      <el-col :span="20" :sm="17">
        <div class="col-inner-wrapper col-images">
          <div class="main-img-compare">
            <div class="img-wrapper" v-if="currentBaselineCompareImage">
              <el-button class="remove-btn" size="small" @click="removeImageFromCompares(currentBaselineCompareImage)">
                <el-icon name="i-exit-ab--32" size="sm"/>
              </el-button>
              <img :src="currentBaselineCompareImage.thumbnailURL">
            </div>
          </div>
          <div class="second-imgs-compare">
            <div class="img-wrapper" v-for="image in currentCompareImages" :key="image.id">
              <el-button class="add-btn" size="small" @click="setToBaseline(image)">
                <el-icon name="i-add-create-ab--32" size="sm"/>
              </el-button>
              <el-button class="remove-btn" size="small" @click="removeImageFromCompares(image)">
                <el-icon name="i-exit-ab--32" size="sm"/>
              </el-button>
              <img :src="image.thumbnailURL">
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="1" :sm="3">
        <div class="col-inner-wrapper">
          <el-button @click="submitImagesToCompares" :disabled="!((currentCompareImages.length && currentBaselineCompareImage) || currentCompareImages.length >= 2)">Compare</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CopmareRaceImageFooter',
  computed: {
    ...mapGetters({
      currentCompareImages: 'race/getComparesImagesByCurrentRaceId',
      currentBaselineCompareImage: 'race/getCurrentBaselineComparesImages'
    }),
  },
  methods: {
    ...mapActions({
      submitImagesToCompares: 'race/submitImagesToCompares',
      clearRaceComparesImages: 'race/clearRaceComparesImages',
      removeImageFromCompares: 'race/removeImageFromCompares',
      setToBaseline: 'race/setToBaseline'
    })
  }
}
</script>

<style lang="scss" scoped>
  .compare-footer {
    height: 100px;
    margin-top: auto;
    background-color: white;
    border-top: 2px solid rgba(38, 104, 197, 0.15);
    ::v-deep {
      .el-row {
        height: 100px;
      }
    }
  }
  .close-btn {
    padding: 0;
  }
  .col-inner-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    &.col-images {
      justify-content: space-between;
      .second-imgs-compare {
        display: flex;
      }
    }
  }

  .img-wrapper {
    position: relative;
    width: 120px;
    margin-right: 10px;
    img {
      width: 100%;
    }
  }

  .remove-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    padding: 0;
    height: 18px;
  }
  .add-btn {
    position: absolute;
    top: 4px;
    left: 4px;
    padding: 0;
    height: 18px;
  }
</style>
